export default "__VITE_ASSET__DBqICv77__"